import React from "react";

export default function ServiceGlyph({ type }) {
    const commonProps = {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.8,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
    };

    const icons = {
        "icon-talk": (
            <>
                <path d="M7 10.5v-2a5 5 0 0 1 10 0v2" />
                <path d="M12 14.5a3 3 0 0 0 3-3v-3a3 3 0 0 0-6 0v3a3 3 0 0 0 3 3Z" />
                <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0" />
                <path d="M12 18v2.5" />
                <path d="M8.5 20.5h7" />
            </>
        ),
        "icon-workshop": (
            <>
                <path d="M4 18.5h16" />
                <path d="M6 16.5v-9h12v9" />
                <path d="M9 10.5h6" />
                <path d="M9 13.5h4" />
                <path d="M7.5 5.5 12 3.5l4.5 2" />
            </>
        ),
        "icon-checklist": (
            <>
                <path d="M8 6.5h11" />
                <path d="M8 12h11" />
                <path d="M8 17.5h11" />
                <path d="m3.8 6.5.9.9 1.8-2" />
                <path d="m3.8 12 .9.9 1.8-2" />
                <path d="m3.8 17.5.9.9 1.8-2" />
            </>
        ),
        "icon-prevention": (
            <>
                <path d="M12 3.8 19 7v5.3c0 4-2.6 7.1-7 8.1-4.4-1-7-4.1-7-8.1V7l7-3.2Z" />
                <path d="M9.5 12h5" />
                <path d="M12 9.5v5" />
            </>
        ),
        "icon-nutrition": (
            <>
                <path d="M12 20c4-2 6.5-5.5 6.5-9 0-2.2-1.3-3.8-3.4-3.8-1.4 0-2.4.7-3.1 1.7-.7-1-1.7-1.7-3.1-1.7-2.1 0-3.4 1.6-3.4 3.8 0 3.5 2.5 7 6.5 9Z" />
                <path d="M14.5 4.5c1.2-.8 2.4-1 3.8-.7-.2 1.3-.8 2.4-2 3.2" />
            </>
        ),
        "icon-training": (
            <>
                <path d="M4.5 18.5h15" />
                <path d="M6.5 16.5v-10h11v10" />
                <path d="M9 9.5h6" />
                <path d="M9 12.5h6" />
                <path d="M10.5 20.5h3" />
                <path d="M12 16.5v4" />
            </>
        ),
        "icon-government": (
            <>
                <path d="M4.5 20.5h15" />
                <path d="M5.5 8.5 12 4l6.5 4.5H5.5Z" />
                <path d="M7 10.5v7" />
                <path d="M12 10.5v7" />
                <path d="M17 10.5v7" />
            </>
        ),
        "icon-observatory": (
            <>
                <path d="M5 18.5h14" />
                <path d="M7.5 15V9.5" />
                <path d="M12 15V6.5" />
                <path d="M16.5 15v-3" />
                <path d="m6 12 4-3 3 1.5 4-4" />
            </>
        ),
        "icon-hospital": (
            <>
                <path d="M4.5 20.5h15" />
                <path d="M6.5 20.5V7.5h11v13" />
                <path d="M9 11h6" />
                <path d="M12 8v6" />
                <path d="M9.5 20.5v-4h5v4" />
            </>
        ),
        "icon-emergency": (
            <>
                <path d="M5 15.5V10l3-2.5h6l2.5 2.5H19v5.5" />
                <path d="M7 15.5h10" />
                <path d="m10 10.5 2-2 2 2" />
                <circle cx="8" cy="17.5" r="1.5" />
                <circle cx="16" cy="17.5" r="1.5" />
            </>
        ),
        "icon-medicine": (
            <>
                <path d="M7.5 7.5h9" />
                <path d="M9 4.5h6" />
                <path d="M8 7.5v10h8v-10" />
                <path d="M10.5 12h3" />
                <path d="M12 10.5v3" />
            </>
        ),
        "icon-community": (
            <>
                <circle cx="9" cy="9" r="2.5" />
                <circle cx="15.5" cy="8" r="2" />
                <path d="M4.5 18c.8-2.5 2.9-4 5.5-4s4.7 1.5 5.5 4" />
                <path d="M14 14.8c1.8.2 3.1 1.2 4 3.2" />
            </>
        ),
        "icon-clinic": (
            <>
                <path d="M5.5 20.5v-14h8v14" />
                <path d="M13.5 10.5h5v10" />
                <path d="M8 9h2" />
                <path d="M8 12.5h2" />
                <path d="M8 16h2" />
                <path d="M16 14h.5" />
                <path d="M16 17h.5" />
            </>
        ),
        "icon-lab": (
            <>
                <path d="M10 4.5h4" />
                <path d="M11 4.5v5l-4.5 7.5A2 2 0 0 0 8.2 20h7.6a2 2 0 0 0 1.7-3l-4.5-7.5v-5" />
                <path d="M9 14h6" />
            </>
        ),
        "icon-shield-plus": (
            <>
                <path d="M12 3.8 19 7v5.3c0 4-2.6 7.1-7 8.1-4.4-1-7-4.1-7-8.1V7l7-3.2Z" />
                <path d="M9.5 12h5" />
                <path d="M12 9.5v5" />
            </>
        ),
        "icon-imaging": (
            <>
                <rect x="4.5" y="6" width="15" height="10.5" rx="1.8" />
                <path d="M9 18.5h6" />
                <path d="M12 16.5v2" />
                <circle cx="12" cy="11.2" r="2.2" />
                <path d="M12 8v1.2" />
                <path d="M12 13.4v1.2" />
            </>
        ),
        "icon-pharma": (
            <>
                <path d="M8 6.5 17.5 16a2.8 2.8 0 1 1-4 4L4 10.5a2.8 2.8 0 0 1 4-4Z" />
                <path d="m10.5 9 4.5 4.5" />
            </>
        ),
        "icon-research": (
            <>
                <path d="M10 4.5a2.8 2.8 0 1 1 5.6 0c0 1.2-.4 2.2-1.1 3.1l-1.1 1.2" />
                <path d="M11.8 8.8 9 11.6" />
                <path d="M7.8 12.4h5.6" />
                <path d="M8.8 12.4 6.5 18.5" />
                <path d="M13.6 12.4 17.5 20" />
                <path d="M5.5 20h14" />
            </>
        ),
        "icon-ruler": (
            <>
                <path d="m7 17 10-10 2 2-10 10H7v-2Z" />
                <path d="M11 9.5 14.5 13" />
                <path d="M10 14.5h1.5" />
                <path d="M8.5 16h1" />
            </>
        ),
        "icon-lock": (
            <>
                <rect x="6.5" y="11" width="11" height="8.5" rx="1.8" />
                <path d="M9 11V8.8a3 3 0 0 1 6 0V11" />
                <circle cx="12" cy="15.3" r="1.1" />
                <path d="M12 16.4v1.6" />
            </>
        ),
        "icon-tv": (
            <>
                <rect x="4.5" y="6" width="15" height="10.5" rx="2.2" />
                <path d="M10 18.5h4" />
                <path d="M12 16.5v2" />
                <path d="m9.2 3.8 2.8 2.5 2.8-2.5" />
            </>
        ),
        "icon-social": (
            <>
                <rect x="4.5" y="4.5" width="6" height="6" rx="1.6" />
                <rect x="13.5" y="4.5" width="6" height="6" rx="1.6" />
                <rect x="4.5" y="13.5" width="6" height="6" rx="1.6" />
                <rect x="13.5" y="13.5" width="6" height="6" rx="1.6" />
            </>
        ),
        "icon-cap": (
            <>
                <path d="m3.8 9.3 8.2-4 8.2 4-8.2 4-8.2-4Z" />
                <path d="M7 11.7v3.1c1.5 1.2 3.2 1.8 5 1.8s3.5-.6 5-1.8v-3.1" />
                <path d="M20.2 9.5v5.3" />
                <path d="M20.2 14.8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" />
            </>
        ),
        "icon-video": (
            <>
                <rect x="4.5" y="6.5" width="10.8" height="11" rx="2" />
                <path d="m15.3 10.2 4.2-2.4v8.4l-4.2-2.4" />
                <path d="m9.4 10 3.4 2-3.4 2Z" />
            </>
        ),
        "icon-badge": (
            <>
                <path d="M12 4.5 14 6l2.5-.1.7 2.3 1.9 1.6-1 2.1.3 2.5-2.4.8-1.4 2.1-2.2-.9-2.2.9-1.4-2.1-2.4-.8.3-2.5-1-2.1 1.9-1.6.7-2.3L10 6l2-1.5Z" />
                <path d="M9.5 12h5" />
            </>
        ),
        "icon-chat": (
            <>
                <path d="M5.5 7.5A3 3 0 0 1 8.5 4.5h7a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H11l-3.8 3v-3H8.5a3 3 0 0 1-3-3v-4Z" />
                <path d="M9.5 9.5h5" />
            </>
        ),
        "icon-article": (
            <>
                <rect x="5.5" y="4.5" width="13" height="15" rx="2" />
                <path d="M8.5 8h7" />
                <path d="M8.5 11.5h7" />
                <path d="M8.5 15h4.5" />
            </>
        ),
        "icon-mail": (
            <>
                <rect x="4.5" y="6.5" width="15" height="11" rx="2" />
                <path d="m5.5 8 6.5 5 6.5-5" />
            </>
        ),
        "icon-mic": (
            <>
                <path d="M12 14.5a3 3 0 0 0 3-3v-4a3 3 0 0 0-6 0v4a3 3 0 0 0 3 3Z" />
                <path d="M6.5 11.5a5.5 5.5 0 0 0 11 0" />
                <path d="M12 17v3.5" />
                <path d="M9 20.5h6" />
            </>
        ),
        "icon-megaphone": (
            <>
                <path d="M4.5 11.2v1.6a1.8 1.8 0 0 0 1.8 1.8h1.2l1.3 3.2h1.8l-1-3.2h1.5l5.5 3.2V6.2l-5.5 3.2H6.3a1.8 1.8 0 0 0-1.8 1.8Z" />
            </>
        ),
        "icon-broadcast": (
            <>
                <circle cx="12" cy="12" r="1.5" />
                <path d="M8.5 8.5a5 5 0 0 0 0 7" />
                <path d="M15.5 8.5a5 5 0 0 1 0 7" />
                <path d="M5.5 5.5a9 9 0 0 0 0 13" />
                <path d="M18.5 5.5a9 9 0 0 1 0 13" />
            </>
        ),
        "icon-bolt": (
            <>
                <path d="M13.2 3.8 6.8 12h4l-1 8.2 7.4-10.4h-4.2l.2-6Z" />
            </>
        ),
        "icon-clipboard": (
            <>
                <rect x="6" y="5.5" width="12" height="15" rx="2" />
                <path d="M9 5.5h6" />
                <path d="M10 3.8h4a1 1 0 0 1 1 1v1.7H9V4.8a1 1 0 0 1 1-1Z" />
                <path d="M9.5 11h5" />
                <path d="M9.5 14.5h5" />
            </>
        ),
        "icon-stethoscope": (
            <>
                <path d="M8 4.8v5a4 4 0 0 0 8 0v-5" />
                <path d="M8 7.5H6.6a1.6 1.6 0 0 1-1.6-1.6v-.6" />
                <path d="M16 7.5h1.4A1.6 1.6 0 0 0 19 5.9v-.6" />
                <path d="M12 13.8v2.2a3 3 0 0 0 3 3h1.2" />
                <circle cx="18.2" cy="19" r="1.8" />
            </>
        ),
        "icon-heartbeat": (
            <>
                <path d="M12 20c4-2 6.5-5.5 6.5-9 0-2.2-1.3-3.8-3.4-3.8-1.4 0-2.4.7-3.1 1.7-.7-1-1.7-1.7-3.1-1.7-2.1 0-3.4 1.6-3.4 3.8 0 3.5 2.5 7 6.5 9Z" />
                <path d="m7.8 12 1.7 0 1-2.2 1.4 4.2 1.1-2h2.2" />
            </>
        ),
        "icon-siren": (
            <>
                <path d="M8 16.5h8" />
                <path d="M9 16.5v-3.7a3 3 0 0 1 6 0v3.7" />
                <path d="M6 19.5h12" />
                <path d="M12 4.5v2.2" />
                <path d="m6.8 7.2 1.5 1.2" />
                <path d="m17.2 7.2-1.5 1.2" />
            </>
        ),
        "icon-chip": (
            <>
                <rect x="7" y="7" width="10" height="10" rx="2" />
                <path d="M10 10h4v4h-4Z" />
                <path d="M9 3.8v2.1" />
                <path d="M12 3.8v2.1" />
                <path d="M15 3.8v2.1" />
                <path d="M9 18.1v2.1" />
                <path d="M12 18.1v2.1" />
                <path d="M15 18.1v2.1" />
                <path d="M3.8 9h2.1" />
                <path d="M3.8 12h2.1" />
                <path d="M3.8 15h2.1" />
                <path d="M18.1 9h2.1" />
                <path d="M18.1 12h2.1" />
                <path d="M18.1 15h2.1" />
            </>
        ),
        "icon-dna": (
            <>
                <path d="M8 5.2c4 0 4 4.8 8 4.8" />
                <path d="M8 18.8c4 0 4-4.8 8-4.8" />
                <path d="M9.2 7.5h5.6" />
                <path d="M9.2 16.5h5.6" />
                <path d="M10 4.8c0 4.8 4 4.8 4 9.6" />
                <path d="M14 4.8c0 4.8-4 4.8-4 9.6" />
            </>
        ),
        "icon-laptop": (
            <>
                <rect x="6" y="5.5" width="12" height="8.5" rx="1.5" />
                <path d="M4.5 17.5h15" />
                <path d="M7.5 17.5 9 19h6l1.5-1.5" />
            </>
        ),
        "icon-scale": (
            <>
                <path d="M12 4.2v15.3" />
                <path d="M8 7.2h8" />
                <path d="m8 7.2-3 5.5h6l-3-5.5Z" />
                <path d="m16 7.2-3 5.5h6l-3-5.5Z" />
                <path d="M8 19.5h8" />
            </>
        ),
        "icon-bandage": (
            <>
                <path d="m8 8 8 8" />
                <path d="m16 8-8 8" />
                <rect x="5.2" y="9.2" width="13.6" height="5.6" rx="2.8" transform="rotate(-45 12 12)" />
                <path d="M10.2 10.2h.01" />
                <path d="M13.8 13.8h.01" />
            </>
        ),
        "icon-brain": (
            <>
                <path d="M9 6.2a2.7 2.7 0 0 0-4.2 2.2c0 .7.2 1.3.6 1.8a2.9 2.9 0 0 0 0 3.6 2.8 2.8 0 0 0 1.5 4.9c.8 0 1.5-.3 2.1-.8" />
                <path d="M15 6.2a2.7 2.7 0 0 1 4.2 2.2c0 .7-.2 1.3-.6 1.8a2.9 2.9 0 0 1 0 3.6 2.8 2.8 0 0 1-1.5 4.9c-.8 0-1.5-.3-2.1-.8" />
                <path d="M12 4.8v14.4" />
                <path d="M9.2 8.2c1.1 0 1.1 1.4 2.3 1.4" />
                <path d="M14.8 8.2c-1.1 0-1.1 1.4-2.3 1.4" />
                <path d="M9.2 15.8c1.1 0 1.1-1.4 2.3-1.4" />
                <path d="M14.8 15.8c-1.1 0-1.1-1.4-2.3-1.4" />
            </>
        ),
        "icon-moon": (
            <>
                <path d="M15.8 4.8a7.2 7.2 0 1 0 3.4 12.9A6.3 6.3 0 0 1 15.8 4.8Z" />
            </>
        ),
        "icon-eye": (
            <>
                <path d="M2.8 12s3.3-5.2 9.2-5.2 9.2 5.2 9.2 5.2-3.3 5.2-9.2 5.2S2.8 12 2.8 12Z" />
                <circle cx="12" cy="12" r="2.3" />
            </>
        ),
        "icon-users": (
            <>
                <circle cx="9" cy="9.2" r="2.2" />
                <circle cx="15.8" cy="8.4" r="1.8" />
                <path d="M5.5 18c.8-2.2 2.6-3.6 5-3.6s4.2 1.4 5 3.6" />
                <path d="M14.4 14.8c1.5.2 2.7 1.2 3.5 2.9" />
            </>
        ),
        "icon-target": (
            <>
                <circle cx="12" cy="12" r="6.8" />
                <circle cx="12" cy="12" r="3.4" />
                <circle cx="12" cy="12" r="1.2" />
                <path d="M18 6l2 0 0 2" />
                <path d="M17.2 6.8 20 4" />
            </>
        ),
        "icon-office": (
            <>
                <path d="M4.5 20.5h15" />
                <path d="M6.5 20.5V6.5h11v14" />
                <path d="M9 9h1.5" />
                <path d="M13.5 9H15" />
                <path d="M9 12.5h1.5" />
                <path d="M13.5 12.5H15" />
                <path d="M10 20.5v-4h4v4" />
            </>
        ),
    };

    if (!icons[type]) {
        return type;
    }

    return <svg {...commonProps}>{icons[type]}</svg>;
}
